import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Bridge } from "@/lib/ipc/bridge";
import { getBridge } from "@/lib/ipc/util";
import {
	type Action,
	getInitialAction,
	getInitialState,
	partialize,
	type State,
	storeName,
} from "@/lib/store/userStore.init";
import { createCustomStorage } from "@/lib/store/util";

const storeBridge = getBridge(Bridge.Store);

const useUserStore = storeBridge
	? create<State & Action>(() => {
			const set = (v) => {
				if (typeof v === "function") {
					v = v();
				}

				storeBridge.dispatch?.(v, storeName);
			};

			return {
				...getInitialState(),
				...getInitialAction(set),
			};
		})
	: create(
			persist(
				(set) => {
					return {
						...getInitialState(),
						...getInitialAction(set),
					};
				},
				{
					version: 0,
					name: storeName,
					storage: createJSONStorage(() => {
						return createCustomStorage();
					}),
					partialize,
				},
			),
		);

storeBridge?.onUpdate?.((state, _storeName) => {
	if (_storeName === storeName) {
		useUserStore.setState(state);
	}
});

export { useUserStore };
